export default __webpack_public_path__ + "static/media/kitchen3-after1-480w.53efa0ee.webp";